import { Box } from "@mui/material";
import { useCallback, useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { handleDownload } from "shared/helpers";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import useTranslation from "shared/helpers/hooks/useTranslation";
import { ERequestStatus } from "store/enums/index.enum";
import {
  ExportSurveyResponses,
  GetAllPinnedSurveys,
  GetSurveyStatisticsGrid,
  PinAllSurveys,
  selectStatisticsData,
  UnPinAllSurveys
} from "store/slicers/campaignDetail";
import SurveyCharts from "./ColumnChart";

const CampaignStatistics = () => {
  const t = useTranslation();
  const data = useSelector(selectStatisticsData);
  const { id } = useParams();
  const dispatch = useAsyncDispatch();

  // const handlePinSurvey = async (survey: ISurveysStatisticsGridResponse) => {
  //   if (survey.isPinned) {
  //     const { meta } = await dispatch(
  //       UnPinSurvey({
  //         campaignID: survey.campaignID,
  //         surveyID: survey.surveyID,
  //       })
  //     );
  //     if (meta.requestStatus !== "fulfilled") {
  //       return;
  //     }
  //     toast.success(t("survey_unpinned"));
  //   } else {
  //     const { meta } = await dispatch(
  //       PinSurvey({ campaignID: survey.campaignID, surveyID: survey.surveyID })
  //     );
  //     if (meta.requestStatus !== "fulfilled") {
  //       return;
  //     }
  //     toast.success(t("survey_pinned"));
  //   }
  //   init();
  // };

  const pinAllSurveys = async () => {
    const action = areAllSurveysPinned ? UnPinAllSurveys : PinAllSurveys;
    const { meta } = await dispatch(action(Number(id)));
    if (meta.requestStatus !== "fulfilled") {
      return;
    }
    toast.success(t("success"));
    init();
  };

  const onExport = async () => {
    const { meta, payload } = await dispatch(ExportSurveyResponses(Number(id)));

    if (meta.requestStatus !== ERequestStatus.FULFILLED) {
      return;
    }
    handleDownload(payload);
  };

  const areAllSurveysPinned = useMemo(() => {
    return data?.displayData?.every((survey) => survey.isPinned);
  }, [data?.displayData]);

  const init = useCallback(async () => {
    if (id) {
      Promise.all([
        dispatch(GetSurveyStatisticsGrid(Number(id))),
        dispatch(GetAllPinnedSurveys(Number(id))),
      ]);
    }
  }, [id, dispatch]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <Box p={4}>
      <SurveyCharts
        campaignName={data?.[0]?.campaignName || ""}
        data={data?.displayData}
        init={init}
        pinAllSurvey={pinAllSurveys}
        areAllSurveysPinned={areAllSurveysPinned}
        onExport={onExport}
      />
    </Box>
  );
};

export default CampaignStatistics;
